import { useEffect } from 'react';

export function ClientTimezoneProvider() {
    useEffect(() => {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const currentCookie = document.cookie.match(/(^|; )tz=([^;]*)/)?.[2];

        if (tz && currentCookie !== tz) {
            document.cookie = `tz=${encodeURIComponent(tz)}; path=/; max-age=31536000`; // 1 year
        }
    }, []);

    return null;
}
